import { VuexModule, Module, Action, Mutation, getModule } from 'vuex-module-decorators';
import { login, logout } from '@/api/users';
import { getUserToken, removeUserToken, setNodeIdList, removeNodeIdList, removeLocUserToken,removeNIMLogin } from '@/utils/cookies';
import store from '@/store';

export interface IUserState {
  account: any
  companyList: any
  companyLimit: any
  user: any
  userAuthorization: any
  qiniuToken: any
  company: any
  name: string
  roles: string
}

@Module({ dynamic: true, store, name: 'user' })
class User extends VuexModule implements IUserState {
  public account:any = sessionStorage.getItem('store') && JSON.parse(sessionStorage.getItem('store') as string).user ? JSON.parse(sessionStorage.getItem('store') as string).user.account : {}
  public companyList:any = sessionStorage.getItem('store') && JSON.parse(sessionStorage.getItem('store') as string).user ? JSON.parse(sessionStorage.getItem('store') as string).user.companyList : {}
  public companyLimit:any = {}
  public user:any = sessionStorage.getItem('store') && JSON.parse(sessionStorage.getItem('store') as string).user ? JSON.parse(sessionStorage.getItem('store') as string).user.user : {}
  public userAuthorization:any = {}
  public qiniuToken:any = {}
  public company:any = sessionStorage.getItem('store') && JSON.parse(sessionStorage.getItem('store') as string).user ? JSON.parse(sessionStorage.getItem('store') as string).user.company : {}
  public name :any= ''
  public roles :any= ''
  getModule: any;
  get getUserId() {
    return this.user.id;
  }
  get getUserName() {
    return this.user.name;
  }
  get getUserMobile() {
    return this.user.mobile;
  }
  get getUserPhone() {
    return this.user.phone_num;
  }
  get getCompanyList() {
    return this.companyList;
  }
  get getCompanyId() {
    let companyId = '0';
    if (this.company && this.company.id) {
      companyId = this.company.id;
    }
    return companyId;
  }
  get getCompany() {
    return this.company;
  }
  get getQiniuToken() {
    return this.qiniuToken;
  }
  get getCompanyName() {
    return this.company.name;
  }
  get getCompanyShortName() {
    return this.company.short_name;
  }
  get getCompanyOnlyId() {
    return this.company.only_id;
  }
  get getCompanyQRCode() {
    return this.company.qr_url;
  }
  get getHeadPic() {
    return this.user.head_img;
  }
  get getAccount() {
    return this.account.account;
  }
  get getAccountId() {
    return this.account.account_id;
  }
  get getAccountMobile() {
    return this.account.mobile;
  }
  get getIsCheckMobile() {
    return this.account.is_check_mobile;
  }
  get getUserInfo() {
    return this.user;
  }
  get getUsetInfoSettings() {
    return this.user.settings;
  }
  get getUserDeptList() {
    return this.company.dept_list;
  }

  @Mutation
  private SET_ACCOUNT(account: {}) {
    this.account = account;
  }

  @Mutation
  private SET_COMPANY_LIST(companyList: any) {
    this.companyList = companyList;
  }
  @Mutation
  private SET_COMPANY_LIMIT(companyLimit: {}) {
    this.companyLimit = companyLimit;
  }

  @Mutation
  private SET_USER_AUTHORIZATION(userAuthorization: {}) {
    this.userAuthorization = userAuthorization;
  }
  @Mutation
  private SET_USER_IS_AUTH_LOGIN(islogin: string) {
    let aa:any = this.userAuthorization;
    aa.is_auth_login = islogin;
    this.userAuthorization = aa;
  }
  @Mutation
  private SET_USER(user: {}) {
    this.user = user;
  }
  @Mutation
  private SET_COMPANY(company: {}) {
    this.company = company;
  }
  @Mutation
  private SET_QINIUTOKEN(qiniuToken: {}) {
    this.qiniuToken = qiniuToken;
  }
  @Action
  public async setMainComapy(company: any) {
    let token: any = getUserToken();
    if (typeof token !== 'object') {
      token = JSON.parse(token as string);
    }
    if (token && parseInt(token.company_id) !== 0) {
      this.SET_COMPANY(company);
    } else {
      this.SET_COMPANY('');
    }
    let arr: number[] = [];
    let menu = [];
    if (this.company && this.company.role && (this.company.role.node)) {
      menu = this.company.role.node.menu;
    } else {
      menu = this.user.node.menu;
    }
    if (menu && menu.length > 0) {
      menu.forEach((item: { id: number, child: any; }) => {
        arr.push(item.id);
        if (item.child && item.child.length > 0) {
          item.child.forEach((child: { id: number; }) => {
            arr.push(child.id);
          });
        }
      });
    }
    setNodeIdList(arr);
    sessionStorage.setItem('store', JSON.stringify(store.state));
    if (!sessionStorage.getItem('reload')) {
      sessionStorage.setItem('reload', 'reload');
      window.location.reload();
    }
  }
  @Action
  public async setLogin(loginInfo: any) {
    if (loginInfo.account) {
      this.SET_ACCOUNT(loginInfo.account);
    }
    if (loginInfo.company) {
      this.SET_COMPANY_LIST(loginInfo.company);
    }
    if (loginInfo.company_limit) {
      this.SET_COMPANY_LIMIT(loginInfo.company_limit);
    }
    if (loginInfo.user) {
      this.SET_USER(loginInfo.user);
    }
    if (loginInfo.user_authorization) {
      this.SET_USER_AUTHORIZATION(loginInfo.user_authorization);
    }
    if (loginInfo.qiniu_token) {
      this.SET_QINIUTOKEN(loginInfo.qiniu_token);
    }
    let token: any = getUserToken();
    if (typeof token !== 'object') {
      token = JSON.parse(token as string);
    }
    if (loginInfo.company && loginInfo.company.length > 0 && token && parseInt(token.company_id) !== 0) {
      let companyInfo = loginInfo.company[0];
      this.SET_COMPANY(companyInfo);
    } else {
      this.SET_COMPANY('');
    }
    let arr: number[] = [];
    let menu = [];
    if (this.company && this.company.role && (this.company.role.node)) {
      menu = this.company.role.node.menu;
    } else if (parseInt(token.company_id) === 0 && this.user && this.user.node) {
      menu = this.user.node.menu;
    }
    if (menu && menu.length > 0) {
      menu.forEach((item: { id: number, child: any; }) => {
        arr.push(item.id);
        if (item.child && item.child.length > 0) {
          item.child.forEach((child: { id: number; }) => {
            arr.push(child.id);
          });
        }
      });
    }
    setNodeIdList(arr);
    sessionStorage.setItem('store', JSON.stringify(store.state));
    if (!sessionStorage.getItem('reload')) {
      sessionStorage.setItem('reload', 'reload');
      window.location.reload();
    }
  }
  @Action
  public async setUserInfo(userInfo: any) {
    this.SET_USER(userInfo);
  }
  @Action
  public async setIsAuthLogin(IsAuthLogin: any) {
    this.SET_USER_IS_AUTH_LOGIN(IsAuthLogin);
  }
  public async setCompany(company: any) {
    let token: any = getUserToken();
    if (typeof token !== 'object') {
      token = JSON.parse(token as string);
    }
    if (token && parseInt(token.company_id) !== 0) {
      this.SET_COMPANY(company);
    } else {
      this.SET_COMPANY('');
    }
  }
  @Action
  public ResetToken() {
    removeUserToken();
    removeLocUserToken();
    removeNodeIdList();
    //腾讯tim停用 20251231
    // removeTIMLogin();
    removeNIMLogin();
    this.SET_COMPANY({});
    this.SET_ACCOUNT({});
    this.SET_COMPANY_LIMIT({});
    this.SET_COMPANY_LIST([]);
    this.SET_USER({});
    this.SET_USER_AUTHORIZATION({});
    sessionStorage.setItem('store', '');
    sessionStorage.setItem('reload', '');
  }

  // @Action
  // public GetUserInfo() {
  //   if (this.token !== '') {
  //     return this.user;
  //   }
  // }

  // @Action
  // public async LogOut() {
  //   if (this.token === '') {
  //     throw Error('LogOut: token is undefined!');
  //   }
  //   // await logout();
  //   this.ResetToken();
  //   location.reload();
  // }
}

export const UserModule = getModule(User);

export const UserId = getModule(User).user.id;
